// Password visibility toggle for login and reset password forms
// Used in templates/login.html and templates/reset_password.html

import { lucideIcon } from './utils/lucide-utils.js';

document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.password-toggle-inside');
  toggles.forEach((toggle) => {
    const targetId = toggle.getAttribute('data-target');
    const input = document.getElementById(targetId);
    const icon = toggle.querySelector('.toggle-icon');
    if (!input || !icon) return;
    icon.replaceChildren(lucideIcon('eye', { size: 16 }));
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      if (input.type === 'password') {
        input.type = 'text';
        icon.replaceChildren(lucideIcon('eye-off', { size: 16 }));
      } else {
        input.type = 'password';
        icon.replaceChildren(lucideIcon('eye', { size: 16 }));
      }
    });
  });
});
